import styled from 'styled-components';
import { Toggle } from '@vtb/ui-kit3';

export const StyledFadedToggle = styled(Toggle)`
  & div {
    color: ${({ theme }) => theme.color.text.tertiary};
  }
`;
